import api from '@/api'


export default {
  namespaced: true,
  state: {
    contests: [],
    sort: '',
    sort_options: ['Newest', 'Oldest'],
    filter: '',
    search: '',
    filter_options: ['Open', 'Closed', 'Completed', 'Bookmarked'],
    loaded_contest: null,
    loading: false
  },
  getters: {
    loadedContest(state, getters, rootState, rootGetters) {
      if (state.loaded_contest) {

        if (rootGetters['account/isLoggedIn']) {
          if (rootState.account.account.contest_bookmarks.includes(state.loaded_contest.id)) {
            state.loaded_contest.bookmarked = true;
            return state.loaded_contest
          } else {
            state.loaded_contest.bookmarked = false;
            return state.loaded_contest
          }
        } else {
          state.loaded_contest.bookmarked = false;
          return state.loaded_contest
        }


      } else {
        return null
      }
    },
    list(state, getters, rootState, rootGetters) {
      return state.contests.filter(c => {
        if (state.search) {
          if (c.talk_about.toLowerCase().includes(state.search.toLowerCase()) || c.brand_name.toLowerCase().includes(state.search.toLowerCase())) {
            return true
          } else {
            return false
          }
        }
        if (state.filter === "Open") {
          return c.status === 1
        } else if (state.filter === "Closed") {
          return c.status === 2
        } else if (state.filter === "Completed") {
          return c.status === 3
        } else if (state.filter === "Bookmarked") {
          if (rootGetters['account/isLoggedIn'] && rootState.account.account) {
            return rootState.account.account.contest_bookmarks.includes(c.id)
          } else {
            return false
          }

        } else {
          return true
        }
      }).sort((a, b) => {
        if (state.sort === "Newest") {
          if (a.id < b.id) {
            return 1
          }
          if (a.id > b.id) {
            return -1
          }
        } else if (state.sort === "Oldest") {
          if (b.id > a.id) {
            return 1
          }
          if (b.id > a.id) {
            return -1
          }
        } else {
          return 0
        }

      }).map(contest => {

        if (rootGetters['account/isLoggedIn'] && rootState.account.account) {
          if (rootState.account.account.contest_bookmarks.includes(contest.id)) {
            contest.bookmarked = true
          } else {
            contest.bookmarked = false
          }
        }


        return contest
      })
    }
  },
  mutations: {
    update_filter(state, filter) {
      state.filter = filter
    },
    update_sort(state, sort) {
      state.sort = sort
    },
    set_contests(state, data) {
      state.contests = data;
    },
    contest_loaded(state, data) {
      state.loaded_contest = data
    }
  },
  actions: {
    async load_contest(context, id) {
      id = parseInt(id)
      //see if we already have it in state
      context.state.loading = true

      let contest = context.state.contests.find(p => {
        return p.id === id
      })
      if (contest) {
        context.commit('contest_loaded', contest)
      } else {
        contest = await api({
          method: "GET",
          url: `/contests/${id}`
        })
        if (contest) {
          context.commit('contest_loaded', contest)
        }
      }
      context.state.loading = false
    },
    async load(context) {
      //load Contests
      //load bookmarks if loggedin
      context.state.loading = true

      let contests = await api({
        method: "GET",
        url: `/contests`
      })
      context.commit('set_contests', contests)

      context.state.loading = false
    }
  }
}
